import { customDebounce } from "../../../utilities/debounce";
import {
  PutElectiveStudiesApiArg,
  PutShareCertificationsApiArg,
  PutShareCountryApiArg,
  PutShareCredentialsApiArg,
  PutShareJobTitleApiArg,
  PutSharePhoneNumberApiArg,
  PutSharePrimaryEmailApiArg,
  usePutElectiveStudiesMutation,
  usePutShareCertificationsMutation,
  usePutShareCountryMutation,
  usePutShareCredentialsMutation,
  usePutShareJobTitleMutation,
  usePutSharePhoneNumberMutation,
  usePutSharePrimaryEmailMutation,
} from "../api/profile.api";
import { shareKey } from "../sections/PublicProfile.types";

export const useUpdatePublicProfileFields = () => {
  const [putSharePrimaryEmail] = usePutSharePrimaryEmailMutation();
  const [putSharePhoneNumber] = usePutSharePhoneNumberMutation();
  const [putShareJobTitle] = usePutShareJobTitleMutation();
  const [putShareCountry] = usePutShareCountryMutation();
  const [putShareCertifications] = usePutShareCertificationsMutation();
  const [putShareCredentials] = usePutShareCredentialsMutation();
  const [putShareElectiveStudies] = usePutElectiveStudiesMutation();
  const updateField = async ({
    key,
    value,
  }: {
    key: shareKey;
    value: boolean;
  }) => {
    const keyToMutation = {
      sharePrimaryEmailAddress: putSharePrimaryEmail,
      sharePhoneNumber: putSharePhoneNumber,
      shareJobTitle: putShareJobTitle,
      shareCountry: putShareCountry,
      shareCertifications: putShareCertifications,
      shareCredentials: putShareCredentials,
      shareElectiveStudies: putShareElectiveStudies,
    };

    const mutation = keyToMutation[key];
    const keyName = key;
    const payloadName = `${key}Payload`;

    const payload = {
      [payloadName]: { [keyName]: value },
    } as PutSharePhoneNumberApiArg &
      PutShareJobTitleApiArg &
      PutShareCountryApiArg &
      PutShareCertificationsApiArg &
      PutShareCredentialsApiArg &
      PutElectiveStudiesApiArg &
      PutSharePrimaryEmailApiArg;
    return mutation(payload);
  };

  return {
    updatePublicProfileShareField: customDebounce(updateField),
  };
};
